The candidate's preferences in an ideal position.

`ProactiveSourcing` candidates may have 0–1 position preferences.
